import * as authMutations from './auth/mutationTypes'

const state = {
  resettingAuth: false
}

const mutations = {
  SET_RESETTING_AUTH (state, resettingAuth) {
    state.resettingAuth = resettingAuth
  }
}

const getters = {
  resettingAuth:
    state => state.resettingAuth
}

const actions = {
  NUKE_STATE (context) {
    context.commit('addFamily/CLEAR_ALL', null, { root: true })

    // context.commit('portalContext/REINITIALIZE_PORTAL_CONTEXT', null, { root: true })

    context.commit('SET_RESETTING_AUTH', true)
    context.commit(authMutations.SET_INITIAL_STATE, null, { root: true })
    context.commit('SET_RESETTING_AUTH', false)

    context.commit('reporting/CLEAR_REPORTING', null, { root: true })
    context.commit('CLEAR_BILLING', null, { root: true })
    context.commit('hiddenRouteData/CLEAR_HIDDEN_ROUTE_PARAMS_STATE', null, { root: true })
    // group selector:
    context.commit('groupSelector/CLEAR_ALL', null, { root: true });
  }
}

export const cacheBuster = { namespaced: true, state, mutations, getters, actions }
